import { Box, Stack, Typography } from '@mui/material';
import AssignmentTurnedIn from '@mui/icons-material/AssignmentTurnedIn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { selectSettings } from '../../settings/settingsSlice';
import { useAppSelector } from '../../../app/hooks';

const registrationBenefitsTexts = {
    title: {
        pl: 'Zakończ proces z rejestracją',
        en: 'Finish process with registration',
        de: 'Vorgang mit Registrierung abschließen',
    },
    benefits: [
        {
            pl: 'Kontynuacja procesu z klientem w systemie',
            en: 'Continue the process with the client in the system',
            de: 'Vorgang mit dem Kunden im System fortsetzen',
        },
        {
            pl: 'Wirtualna kopia dokumentu',
            en: 'Virtual copy of the document',
            de: 'Virtuelle Kopie des Dokuments',
        },
        {
            pl: 'Dodatkowe funkcjonalności',
            en: 'Additional features',
            de: 'Zusätzliche Funktionen',
        },
    ],
};

export const RegistrationBenefitsBox = () => {
    const { locale } = useAppSelector(selectSettings);
    const lang = locale === 'en-US' ? 'en' : locale;

    return (
        <>
            <Box display="flex" alignItems="center" mb={1}>
                <AssignmentTurnedIn sx={{ color: 'success.main', mr: 1 }} />
                <Typography variant="subtitle1" fontWeight="bold">
                    {registrationBenefitsTexts.title[lang]}
                </Typography>
            </Box>

            <Stack spacing={0.5}>
                {registrationBenefitsTexts.benefits.map((item, index) => (
                    <Box key={index} display="flex" alignItems="center">
                        <CheckCircleIcon fontSize="small" sx={{ color: 'success.main', mr: 1 }} />
                        <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                            {item[lang]}
                        </Typography>
                    </Box>
                ))}
            </Stack>
        </>
    );
};
